import {Reducer} from "redux";
import {HIDE_NOTIFICATION, SHOW_LOADING, SHOW_NOTIFICATION} from "../action_types/notificationActionTypes";

/**
 * Reducer state
 */
interface INotificationReducerState {
    readonly display: boolean;
    readonly loading: boolean;
    readonly text: string;
}

/**
 * Initial reducer state
 * @type {{display: boolean; loading: boolean; text: string}}
 */
const initialState: INotificationReducerState = {
    display: false,
    loading: false,
    text: '',
};

/**
 * Notification reducers
 */
const NotificationReducer: Reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SHOW_NOTIFICATION: {
            return {
                ...state,
                display: true,
                loading: false,
                text: action.message,
            }
        }

        case SHOW_LOADING: {
            return {
                ...state,
                display: false,
                loading: true,
            }
        }

        case HIDE_NOTIFICATION: {
            return {
                ...state,
                display: false,
                loading: false,
            }
        }

        /**
         * Default reducer
         */
        default:
            return state;
    }
};

export default NotificationReducer;


// WEBPACK FOOTER //
// ./src/reducers/notificationReducer.ts